import { notification } from "antd";
import { DcOffLineHost } from "../../config";
import { LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS, LOGOUT } from "../Types";
import { jwtDecode } from "jwt-decode";
import { Navigate } from "react-router-dom";

export const loginUser = (credentials) => async (dispatch) => {
  dispatch({ type: LOGIN_REQUEST });

  try {
    const response = await fetch(`${DcOffLineHost}api/users/signin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    });

    const data = await response.json();
    // console.log(data);

    if (!response.ok) {
      throw new Error(data?.error || "Erreur de connexion");
    }

    dispatch({ type: LOGIN_SUCCESS, payload: data?.user });

    if (data?.token) {
      localStorage.setItem("token", data?.token);
    }
    localStorage.setItem("user", JSON.stringify(data?.user));
    localStorage.setItem("refreshToken", JSON.stringify(data?.refreshToken));
    // console.log(data);
    // console.log(data.accessToken);

    return data;
  } catch (error) {
    dispatch({ type: LOGIN_FAILURE, payload: error?.message });
    // notification.error({
    //         message: error.message,
    //         duration: 6,
    //       });
    throw error;
  }
};

// export const logoutUser = () => (dispatch) => {
//     localStorage.removeItem("token");
//     dispatch({ type: LOGOUT });
//   };

export const loadUserFromStorage = () => (dispatch) => {
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user");

  if (token && user) {
    dispatch({
      type: LOGIN_SUCCESS,
      payload: JSON.parse(user),
    });
  } else {
    dispatch({ type: LOGIN_FAILURE, payload: null });
  }
};

// const isTokenExpired = (token) => {
//   try {
//     const decoded = jwtDecode(token);
//     return decoded.exp < Date.now() / 1000;
//   } catch {
//     return true;
//   }
// };

export const logoutUser = () => (dispatch) => {
  const token = localStorage.getItem("token");

  if (!token) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("refreshToken");

    dispatch({ type: LOGOUT });

    notification.success({
      message: "Déconnexion réussie",
      description: "Vous avez été déconnecté avec succès.",
      duration: 5,
    });

    // return;
    // <Navigate to="/" />;y
  }

  fetch(`${DcOffLineHost}api/users/logout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res.json().then((data) => ({ status: res.status, data })))
    .then(({ status, data }) => {
      if (status >= 200 && status < 300) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("refreshToken");

        dispatch({ type: LOGOUT });

        notification.success({
          message: data?.message || "Déconnexion réussie",
          description: "Vous avez été déconnecté avec succès.",
          duration: 5,
        });
        // return <Navigate to="/" />;
      } else {
        notification.error({
          message: "Erreur lors de la déconnexion",
          description:
            data?.message || "Impossible de terminer la déconnexion.",
          duration: 6,
        });
      }
    })
    .catch((error) => {
      notification.error({
        message: "Erreur réseau",
        description: error.message || "Une erreur de connexion s’est produite.",
        duration: 6,
      });
    });
};

export const refreshAuthToken = () => async (dispatch) => {
  try {
    // const refreshToken = localStorage.getItem("refreshToken");
    const refreshToken = JSON.parse(localStorage.getItem("refreshToken"));

    // console.log(refreshToken);
    if (!refreshToken) {
      throw new Error("Aucun refresh token trouvé");
    }

    const response = await fetch(`${DcOffLineHost}api/users/refresh-token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ refreshToken }),
    });
    const data = await response.json();
    // console.log(data);

    if (!response.ok) {
      throw new Error(
        data?.message || "Erreur lors du rafraîchissement du token"
      );
    }

    // ✅ Mise à jour du token d'accès
    localStorage.setItem("token", data?.token);

    // 🎯 AMÉLIORATION : Mise à jour du refresh token si fourni
    if (data?.refreshToken) {
      localStorage.setItem("refreshToken", JSON.stringify(data?.refreshToken));
    }

    if (data?.user) {
      localStorage.setItem("user", JSON.stringify(data?.user));
      dispatch({ type: LOGIN_SUCCESS, payload: data?.user });
    }

    // Retourner le nouveau token
    return data?.token;
  } catch (error) {
    // En cas d'erreur, déconnecter l'utilisateur
    await dispatch(logoutUser());
    throw error;
  }
};

// export const refreshAuthToken = () => async (dispatch) => {
//   const refreshToken = localStorage.getItem("refreshToken");

//   if (!refreshToken) {
//     await dispatch(logoutUser());
//     throw new Error("Aucun refresh token trouvé");
//   }

//   return fetch(`${DcOffLineHost}api/users/refresh-token`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({ refreshToken }),
//   })
//     .then((res) => res.json().then((data) => ({ status: res?.status, data })))
//     .then(({ status, data }) => {
//       if (status >= 200 && status < 300) {
//         localStorage.setItem("token", data?.token);
//         if (data?.refreshToken) {
//           localStorage.setItem("refreshToken", data?.refreshToken);
//         }
//         if (data.user) {
//           localStorage.setItem("user", JSON.stringify(data?.user));
//           dispatch({ type: LOGIN_SUCCESS, payload: data?.user });
//         }
//         return data?.token;
//       } else {
//         return Promise.reject(new Error(data?.message || "Échec du rafraîchissement du token"));
//       }
//     })
//     .catch(async (error) => {
//       await dispatch(logoutUser());
//       throw error;
//     });
// };

// export const refreshAuthToken = () => (dispatch) => {
//   const storedRefreshToken = localStorage.getItem("refreshToken");

//   if (!storedRefreshToken) {
//     dispatch(logoutUser());
//     return Promise.reject(new Error("Aucun refresh token trouvé"));
//   }

//   let refreshToken;
//   try {
//     refreshToken = JSON.parse(storedRefreshToken);
//   } catch (e) {
//     dispatch(logoutUser());
//     return Promise.reject(new Error("Refresh token invalide"));
//   }

//   return fetch(`${DcOffLineHost}api/...........`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({ refreshToken }),
//   })
//     .then((res) =>
//       res.json().then((data) => ({
//         status: res.status,
//         data,
//       }))
//     )
//     .then(({ status, data }) => {
//       if (status >= 200 && status < 300) {
//         localStorage.setItem("token", data?.token);
//         if (data?.refreshToken) {
//           localStorage.setItem("refreshToken", JSON.stringify(data?.refreshToken));
//         }

//         if (data?.user) {
//           localStorage.setItem("user", JSON.stringify(data.user));
//           dispatch({ type: LOGIN_SUCCESS, payload: data.user });
//         }

//         return data.token;
//       } else {
//         dispatch(logoutUser());
//         dispatch({ type: LOGIN_FAILURE, payload: data?.message });
//         return Promise.reject(new Error(data?.message || "Erreur lors du rafraîchissement du token"));
//       }
//     })
//     .catch((error) => {
//       dispatch(logoutUser());
//       dispatch({ type: LOGIN_FAILURE, payload: error.message });
//       return Promise.reject(error);
//     });
// };
